import { render } from "./App.vue?vue&type=template&id=5438a066"
const script = {}

import "./App.vue?vue&type=style&index=0&id=5438a066&lang=scss"

import exportComponent from "E:\\Documents\\Development\\juwie-giveaway\\juwie-giveaway-portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__